<template>
  <div class="laonlzxls text_center">
    <sec-title
      Text="在线律师"
      desc-text="合肥在线律师推荐，快速为您提供法律服务"
	  :showmore = 'false'
    />
    <div class="laonlzxls_cont between">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="ct_item"
      >
        <qestlaywin :item='item' :imgStyle="{ width: '225px', height: '300px' }" />
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import viewMore from "views/home/components/viewMore";
import qestlaywin from "views/findLawyers/components/qestlaywin";
export default {
  components: {
    secTitle,
    viewMore,
    qestlaywin,
  },
  data: () => ({
	  list:[]
  }),
  created() {
  	this.$http.home.lawyerads({
		ad_id:6,
		limit:5,
		order:'hot',
	}).then( res => {
		this.list = res.data.data
	})
  },
  methods: {},
};
</script>

<style lang="scss" scope>
.laonlzxls {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  .laonlzxls_cont {
    .ct_item {
      width: 225px;
    }
  }
}
</style>